/**
 * Stacking order for the job-detail inline editors.
 *
 * The edit popovers deliberately sit above MUI's modal layer (1300) so they
 * clear the sticky detail header. Anything MUI portals out of a popover — a
 * Select's dropdown, a DatePicker's calendar — lands on that modal layer by
 * default and would therefore paint *behind* the popover that owns it. Those
 * overlays get lifted one step further so they stay on top of their own popover.
 *
 * Keep both values here so the two never drift apart.
 */
export const POPOVER_Z_INDEX = 1500;
export const OVERLAY_Z_INDEX = POPOVER_Z_INDEX + 1;
